<div class="row" *ngIf="products?.length">
  <div class="col-lg-4" *ngFor="let product of products">
    <deloitteai-product-card [product]="product">
      <ng-container sharedCardAction>
        <a
          [routerLink]="['/catalog', catalogName, product.product_id]"
          class="catalog_action"
        >
          See details
          <mat-icon
            [svgIcon]="'deloitte-ai-arrow-right'"
            class="arrow-right"
          ></mat-icon>
        </a>
      </ng-container>
    </deloitteai-product-card>
  </div>
</div>
